import { render, staticRenderFns } from "./ApplicationDeleteOverlay.vue?vue&type=template&id=2b1a9af0&scoped=true"
import script from "./ApplicationDeleteOverlay.vue?vue&type=script&lang=js"
export * from "./ApplicationDeleteOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a9af0",
  null
  
)

export default component.exports